import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useParams } from './use-params';
import { PAPERS_PATH, paperPath } from '@/constants/routes';

export function useRouter() {
  const navigate = useNavigate();
  const params = useParams();
  const router = useMemo(
    () => ({
      back: () => navigate(-1),
      forward: () => navigate(1),
      reload: () => window.location.reload(),
      push: (href: string) => navigate(href),
      replace: (href: string) => navigate(href, { replace: true }),
      novel: (path: string) => {
        navigate(`${paperPath(params.novelId!, path)}${location.search}`);
      },
      prompts: (path: string) => {
        if (location.pathname.startsWith(PAPERS_PATH) || location.pathname.startsWith('/novels')) {
          navigate(`${paperPath(params.novelId!, `prompts${path}`)}${location.search}`);
        } else {
          navigate(`/prompts${path}${location.search}`);
        }
      },
    }),
    [navigate, params.novelId],
  );

  return router;
}
